import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '../../localization/LocalizationManager'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'

interface IInterval {
  startDate: number
  endDate: number
}

interface IProps {
  isShown: boolean
  intervals: IInterval[]
  onHide: () => void
  onApply: () => void

  formatInterval: (startDate: number, endDate: number) => string
}

const title = 'Warning'
const description =
  'Some future recurring intervals have restrictions. Submission will proceed for the first interval, but please review:'

@observer
export default class FutureIntervalsRestrictionsDialog extends React.Component<IProps> {
  public render() {
    const { isShown, onHide, onApply, intervals, formatInterval } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={title}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={Localization.translator.ok}
      >
        <div className="tw:text-body-md tw:text-foreground">{description}</div>
        <ul className="tw:my-2 tw:flex tw:max-h-[260px] tw:flex-col tw:gap-1 tw:overflow-y-auto">
          {intervals.map((i, idx) => (
            <li key={idx}>
              <div className="tw:inline-block tw:w-fit tw:rounded tw:bg-muted tw:px-1 tw:py-0.5 tw:text-body-sm tw:text-foreground">
                {formatInterval(i.startDate, i.endDate)}
              </div>
            </li>
          ))}
        </ul>
      </ConfirmDialog>
    )
  }
}
